(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kw-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kw-recently-viewed')) {
    const KEY = 'kora-recently-viewed';
    const read = () => {
      try {
        const list = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };
    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    };
    const el = (tag, cls, text) => {
      const node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text) node.textContent = text;
      return node;
    };

    customElements.define(
      'kw-recently-viewed',
      class extends HTMLElement {
        renderCard(p) {
          const cell = el('div', 'kw-rail__item');
          const card = el('a', 'kw-card');
          card.href = p.url;
          const media = el('span', 'kw-card__media');
          if (p.image) {
            const img = el('img', 'kw-card__img');
            img.src = p.image;
            img.alt = p.title || '';
            img.loading = 'lazy';
            img.width = 600;
            img.height = 750;
            img.addEventListener('error', () => img.remove(), { once: true });
            media.append(img);
          }
          if (p.compare) media.append(el('span', 'kw-card__badge', 'Sale'));
          const price = el('span', 'kw-card__price');
          price.append(el('span', '', p.price));
          if (p.compare) price.append(el('s', '', p.compare));
          card.append(media, el('span', 'kw-card__title', p.title), price);
          cell.append(card);
          return cell;
        }

        async refresh(items, cells, track, current) {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const money = (cents) =>
            'Rs. ' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
          const sized = (src) => {
            if (!src) return '';
            const url = new URL(src, window.location.origin);
            url.searchParams.set('width', '600');
            return url.href;
          };
          const results = await Promise.all(
            items.map(async (p) => {
              try {
                const getJson = (handle) =>
                  fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
                    headers: { Accept: 'application/json' },
                  });
                let res = await getJson(p.handle);
                if (res.status === 404) {
                  // Renamed sarees redirect on the product page but not on .js,
                  // so follow the page redirect to find the new handle.
                  const page = await fetch(root + 'products/' + encodeURIComponent(p.handle), { method: 'HEAD' });
                  const match = page.ok && new URL(page.url).pathname.match(/\/products\/([^/?#]+)/);
                  if (!match || match[1] === p.handle) return { old: p, gone: true };
                  res = await getJson(decodeURIComponent(match[1]));
                  if (res.status === 404) return { old: p, gone: true };
                }
                if (!res.ok) return { old: p };
                const d = await res.json();
                return {
                  old: p,
                  fresh: {
                    handle: d.handle,
                    title: d.title,
                    url: d.url,
                    image: sized(d.featured_image),
                    price: money(d.price),
                    compare: d.compare_at_price > d.price ? money(d.compare_at_price) : '',
                  },
                };
              } catch (e) {
                return { old: p };
              }
            })
          );

          let list = read();
          let changed = false;
          results.forEach(({ old, fresh, gone }) => {
            const cell = cells.get(old.handle);
            if (gone || (fresh && fresh.handle === current)) {
              if (cell) cell.remove();
              list = list.filter((x) => x && x.handle !== old.handle);
              changed = true;
              return;
            }
            if (!fresh) return;
            const same = ['handle', 'title', 'url', 'price', 'compare'].every((k) => fresh[k] === (old[k] || '')) && fresh.image === sized(old.image);
            if (same) return;
            if (cell) cell.replaceWith(this.renderCard(fresh));
            list = list
              .map((x) => (x && x.handle === old.handle ? fresh : x))
              .filter((x, i, arr) => x && arr.findIndex((y) => y && y.handle === x.handle) === i);
            changed = true;
          });
          if (changed) write(list);
          if (!track.children.length) this.hidden = true;
          if (typeof track.update === 'function') requestAnimationFrame(() => track.update());
        }

        connectedCallback() {
          const max = parseInt(this.dataset.max, 10) || 8;
          const current = this.dataset.current || '';
          let list = read();

          if (this.dataset.product) {
            try {
              const item = JSON.parse(this.dataset.product);
              list = [item, ...list.filter((p) => p && p.handle !== item.handle)].slice(0, 20);
              write(list);
            } catch (e) {}
          }

          const items = list.filter((p) => p && p.handle && p.handle !== current).slice(0, max);
          if (!items.length) return;

          const track = this.querySelector('.kw-rail__track');
          const cells = new Map();
          items.forEach((p) => {
            const cell = this.renderCard(p);
            cells.set(p.handle, cell);
            track.append(cell);
          });

          // Saved snapshots go stale when a saree is renamed, re-photographed or
          // re-priced, so refresh each one from the store and drop removed ones.
          this.refresh(items, cells, track, current);

          this.hidden = false;
          if (typeof track.update === 'function') requestAnimationFrame(() => track.update());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
